module.exports = __webpack_public_path__ + "static/indianperformancesolutions-b1da3aa0f6b350e6678c6af4632a2edd.svg";